import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    modalTitle: {
        id: "test.newTask.modal.title",
    },
    rhythm: {
        id: "exerciseTypes.rhythm",
    },
    melody: {
        id: "exerciseTypes.melody",
    },
    other: {
        id: "exerciseTypes.other",
    },
    theory: {
        id: "exerciseTypes.theory",
    },
    cancel: {
        id: "general.cancel",
    },
    close: {
        id: "general.close",
    },
    modalLimitReached: {
        id: "test.newTask.modal.limitReached",
    },
});

export default messages;
